import NaveBarPaginas from "../Layout/NaveBarPaginas";
import styles from "./ResultadosP.module.css";
import res1 from "../../Imgs/Res/res1.png";
import res2 from "../../Imgs/Res/res2.png";
import res3 from "../../Imgs/Res/res3.png";
import res4 from "../../Imgs/Res/res4.png";
function ResultadosP() {
  return (
    <div className={styles.container}>
      <NaveBarPaginas></NaveBarPaginas>

      {/*Res01*/}
      <div className={styles.conteudo}>
        <img src={res1} alt="capa"></img>
        <div className={styles.desc}>
          <h2>
            Por uma cartografia escolar interativa: jogo digital para a
            alfabetização cartográfica no ensino fundamental
          </h2>
          <p>
            <span>Autor(es):</span> Gabriela Dambrós
          </p>
          <p>
            <span>Tipo:</span> Dissertação de mestrado
          </p>
          <p>
            <span>Resumo:</span> A Geografia Escolar necessita apropriar-se de
            recursos didáticos e metodologias consoantes com a
            contemporaneidade, integrando as tecnologias de informação e
            comunicação ao processo educativo. Desta maneira, a presente
            pesquisa teve como objetivo geral contribuir para a práxis da
            cartografia escolar via inserção de tecnologias de informação e
            comunicação. Os objetivos específicos foram: (a) elaborar um jogo
            digital para apoio ao ensino e aprendizagem da alfabetização
            cartográfica; (b) validar o jogo com alunos do sexto ano do ensino
            fundamental; (c) analisar a potencialidade educativa, os limites e
            as possibilidades dos jogos incorporados na prática pedagógica de
            Geografia.
          </p>
          <a href="https://pedrinhoproject.files.wordpress.com/2014/05/dissertacao_gabriela_dambros.pdf">
            Download da dissertação
          </a>
          <br></br>
          <a
            target="_blank"
            href="https://pedrinhoproject.files.wordpress.com/2014/05/dissertacao_gabriela_dambros.pdf"
            rel="noreferrer"
          >
            Jogo digital “Pedrinho e Pedrita conhecendo o mapa”
          </a>
        </div>
      </div>

      

      {/*Res02*/}
      <div className={styles.conteudo}>
        <img src={res2} alt="capa"></img>
        <div className={styles.desc}>
          <h2>
            Potencialidades dos retrogames para o ensino e aprendizagem de
            Geografia: analisando Grand Theft Auto 2
          </h2>
          <p>
            <span>Autor(es):</span> Thales Roberto Barbosa Rodrigues
          </p>
          <p>
            <span>Tipo:</span> Trabalho de Conclusão de Curso - Tcc
          </p>
          <p>
            <span>Resumo:</span> Os videogames são um tema ainda incipiente no
            meio acadêmico, em especial nas áreas não relacionadas à informática
            ou mídias. Situando-se no ensino de Geografia, este trabalho, de
            natureza qualitativa, busca discutir uma categoria específica dos
            jogos eletrônicos, os retrogames (jogos retro) e seu potencial como
            recurso didático para a aprendizagem desta área do saber na educação
            básica.
          </p>
          <a
            target="_blank"
            href="https://pergamum.ufpel.edu.br/pergamumweb/vinculos/0000da/0000da38.pdf"
            rel="noreferrer"
          >
            Download do Tcc
          </a>
        </div>
      </div>

      {/*Res03*/}
      <div className={styles.conteudo}>
        <img src={res3} alt="capa"></img>
        <div className={styles.desc}>
          <h2>Jogo de tabuleiro: orientação geográfica</h2>
          <p>
            <span>Autor(es):</span> Márcio Da Costa Leal Junior
          </p>
          <p>
            <span>Tipo:</span> Trabalho de Conclusão de Curso - Tcc / Jogo
          </p>
          <p>
            <span>Resumo:</span> O jogo materializa-se como produto final do
            trabalho de Conclusão de Curso - Tcc
          </p>
          <a
            target="_blank"
            href="https://cartogame.blogspot.com/2022/04/jogo-de-tabuleiro-orientacao-geografica.html"
            rel="noreferrer"
          >
            Acesso ao Jogo
          </a>
          <p>Em breve link download do Tcc</p>
        </div>
      </div>

      {/*Res04*/}
      <div className={styles.conteudo}>
        <img src={res4} alt="capa"></img>
        <div className={styles.desc}>
          <h2>
            Potencialidades dos jogos digitais no ensino de Geografia: O
            universo de League of Legends
          </h2>
          <p>
            <span>Autor(es):</span> Kelvin vasconcellos da vara
          </p>
          <p>
            <span>Tipo:</span> Trabalho de Conclusão de Curso - Tcc
          </p>
          <p>
            <span>Resumo:</span> Os jogos digitais atualmente apresentam um
            grande poder de influência e engajamento. O número de jogadores e
            fãs que acompanham e consomem toda uma rede de conteúdos derivadas
            de seus jogos preferidos é gigantesco, em muitos casos ultrapassando
            com facilidade números de grandes meios de comunicação que já estão
            bem estabelecidos dentro da sociedade. A significativa e crescente
            união das Tecnologias Digitais de Informação e Comunicação na
            sociedade (TDIC) possibilita múltiplos usos de diferentes
            dispositivos digitais no ambiente escolar, contribuindo para a
            oferta de uma educação de maior qualidade. Em uma realidade onde os
            produtos culturais digitais estão cada vez mais presentes na vida
            dos jovens, os jogos digitais demonstram ter fortes potencialidades
            pedagógicas. Esse trabalho se dedica a analisar essas
            potencialidades no ensino de Geografia, se atentando às temáticas da
            Geografia Política e Geopolítica trabalhando o jogo League of
            Legends, e toda narrativa e universo que o permeia. O trabalho se
            dedica após a contextualização dos conceitos Geografia Política e
            Geopolítica, apontar potencialidades dos jogos digitais para a
            educação, pensando em formas de trabalhar esses conceitos dentro de
            aspectos como a mecânica do jogo, universo que ele está inserido,
            representações étnicas, culturais, econômicas, sociais, físicas,
            políticas e governamentais, além das disputas culturais, políticas e
            de território existentes no universo.
          </p>
          <a
            target="_blank"
            href="https://pergamum.ufpel.edu.br/pergamumweb/vinculos/0000da/0000da31.pdf"
            rel="noreferrer"
          >
            Download do Tcc
          </a>
        </div>
      </div>
    </div>
  );
}
export default ResultadosP;
